import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import React, { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { MyMLink } from '../ui-elements/MyMLink';
import { format } from 'react-string-format';
import FormHelperText from '@mui/material/FormHelperText';
import { MyMLabel } from '../ui-elements/MyMLabel';

/** MyMine Version1.5 追加
 * ValidatablePreviewImageDropZone Component
 */
export const ValidatablePreviewImageDropZone = (
  { height,
    removeText,
    imageFile,
    setImageFile,
    isExtensionError,
    setIsExtensionError,
    isSizeError,
    setIsSizeError,
    messageList,
    utility,
    ThumbnailFileSize,
    constants,
    controlSettings
  }) => {
  const makePreviewFileObject = (file) => Object.assign(file, { preview: URL.createObjectURL(file) });

  const onClickRemove = () => {
    setImageFile(null);
    setIsExtensionError && setIsExtensionError(false);
    setIsSizeError(false);
  }

  if (imageFile && !imageFile.preview) {
    makePreviewFileObject(imageFile)
  }

  useEffect(() => {
    if (imageFile) {
      //拡張子チェック
      const extension = imageFile.name.split('.').at(-1).toLowerCase();
      if (extension !== 'jpg' && extension !== 'jpeg' && extension !== 'png') {
        setIsExtensionError && setIsExtensionError(true);
      } else {
        setIsExtensionError && setIsExtensionError(false);
      }
      //ファイルサイズチェック
      if (imageFile.size > ThumbnailFileSize) {
        setIsSizeError(true);
      } else {
        setIsSizeError(false);
      }
    }
  }, [imageFile])

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      "image/jpeg": ['.jpeg'],
      "image/jpg": ['.jpg'],
      "image/png": ['.png'],
    },
    onDrop: (acceptedFiles, fileRejections) => {
      //accept指定外の拡張子の場合
      (fileRejections.length > 0) ? setIsExtensionError && setIsExtensionError(true) : setIsExtensionError && setIsExtensionError(false);
      //accept指定内の拡張子の場合
      if (acceptedFiles.length > 0) {
        setImageFile(makePreviewFileObject(acceptedFiles[0]));
      }
    },
  });

  return (
    <>
      <div {...getRootProps({ className: 'dropzone' })} style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
        borderWidth: 3,
        borderRadius: 2,
        borderColor: (isExtensionError || isSizeError) ? '#d32f2f' : '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        height: height ?? '100%',
        justifyContent: 'center',
        cursor: 'pointer'
      }}>
        <input {...getInputProps()} />
        {imageFile
          ? <img
            src={imageFile.preview}
            alt=''
            style={{ maxWidth: '100%', maxHeight: '100%' }}
            onLoad={() => { URL.revokeObjectURL(imageFile.preview) }}
          />
          : <AddToPhotosIcon sx={{ fontSize: '100px' }} />}
      </div>
      <MyMLabel>{controlSettings.LabelList.lblThumbnailInfo}</MyMLabel>
      <MyMLink sx={{ float: 'right' }} onClick={() => onClickRemove()} >{removeText}</MyMLink>
      {isExtensionError && <FormHelperText error={true}>{messageList.MyM_MSG_E_0014}</FormHelperText>}
      <FormHelperText sx={{ color: '#212529'}} error={isSizeError}>{format(messageList.MyM_MSG_E_0093, Math.floor(utility.convertFileSize(ThumbnailFileSize, constants.FileSize.MB)))}</FormHelperText>
    </>
  );
}